(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/enablesubscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/enablesubscription.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.EnableSubscription = svs.tur.start_subscription.behaviors.Subscription.extend({
    options() {
      return {
        entryModel: new svs.tur.start_subscription.models.EnableEntry(),
        prefix: 'enable'
      };
    },
    onEnableSubscription(subscriptionId, weeklyBetAmount, status, productName) {
      this.entryModel.reset();
      this.entryModel.set({
        subscriptionId,
        weeklyBetAmount,
        productName
      });
      if (status && productName) {
        this.isStandAlone = true;
        this.activateSubscription(status, productName);
      } else {
        this.view.triggerMethod('updateSubscription', subscriptionId, this.activateSubscription.bind(this), error => svs.tur.start_subscription.radio.trigger('handleError', error));
      }
    },
    activateSubscription(status, productName) {
      this.entryModel.set({
        status
      });
      if (status === this.CONSTANTS.STATUS.CREATED || status === this.CONSTANTS.STATUS.PAUSED) {
        this.verifyUser();
      } else {
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'subscription',
          title: 'Din prenumeration är aktiv',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: "Din prenumeration \xE4r aktiv och du deltar i kommande dragningar av ".concat(productName)
          }],
          actions: [{
            title: 'Okej',
            callback: () => {
              svs.events.publish('/subscription/activate/isactive');
              dialog.close(() => {});
            }
          }]
        });
        svs.ui.dialog.api.add(dialog);
      }
    },
    onEnableIsVerified() {
      this.getEntryOrAnnouncement();
    },
    onEnableContinueActivation(subscriptionId) {
      this.entryModel.set({
        subscriptionId
      });
      this.getEntryOrAnnouncement(() => this.triggerPrefixMethod('activationConfirmed'));
    },
    onEnableSubscriptionDefined() {
      this.pollNewSubscription(response => {
        if (response && response.GetSubscriptionRequest) {
          this.view.triggerMethod('showNewSubscription', response, this.entryModel.get('subscriptionId'), this);
          if (this.isStandAlone) {
            svs.components.loader.show();
            setTimeout(() => {
              window.location.href = "".concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?subscriptionId=").concat(this.entryModel.get('subscriptionId'));
            }, 1000);
          }
        }
      });
    },
    onEnableActivationConfirmed() {
      switch (true) {
        case this.entryModel.get('isBankcard') && this.entryModel.get('isEntry'):
          this.entryModel.set('isActivating', true);
          this.showBankcardPaymenttype(this.entryModel, this);
          break;
        case this.entryModel.get('hasActivePayChannel'):
          this.postNewSubscription();
          break;
        case this.entryModel.get('isAutogiro'):
          this.getAutogiroInfo();
          break;
        default:
          svs.tur.start_subscription.radio.trigger('handleError');
          break;
      }
    },
    onEnableMakeCardPayment() {
      this.view.triggerMethod('saveTrackingFromSubscription', this, () => this.makeCardPayment("".concat(Backbone.history.location.href, "?subscriptionId=").concat(this.entryModel.get('newSubId'))));
    },
    verifySpendLimit(proceed) {
      const _this$entryModel$attr = this.entryModel.attributes,
        subscriptionId = _this$entryModel$attr.subscriptionId,
        weeklyBetAmount = _this$entryModel$attr.amount;
      if (weeklyBetAmount && svs.core.detect.feature('ft-omni-3-ktt')) {
        svs.tur.start_subscription.radio.request('checkSpendLimitRenewal', weeklyBetAmount, subscriptionId, this, proceed, 'reactivation');
      } else {
        proceed();
      }
    },

    onEnableShowConfirmSubscription() {
      const onCancel = () => {
        svs.utils.paramHandler.remove({
          key: 'pay'
        });
        svs.events.publish('/subscription/activate/cancel');
      };
      const proceed = () => {
        const actionText = this.entryModel.get('status') === this.CONSTANTS.STATUS.CREATED ? 'Aktivera' : 'Återaktivera';
        const _this$getDialogConfir = this.getDialogConfirmEnableMessage({
            action: actionText
          }),
          title = _this$getDialogConfir.title,
          message = _this$getDialogConfir.message;
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'subscription',
          title,
          message,
          actions: [{
            title: 'Avbryt',
            callback: () => {
              dialog.close();
              onCancel();
            }
          }, {
            title: actionText,
            callback: () => {
              dialog.close(() => {
                this.triggerPrefixMethod('activationConfirmed', this.entryModel.get('status'));
              });
            }
          }]
        });
        svs.ui.dialog.api.add(dialog);
      };
      this.verifySpendLimit(proceed, onCancel);
    },
    getDialogConfirmEnableMessage(_ref) {
      let action = _ref.action;
      let _this$entryModel$attr2 = this.entryModel.attributes,
        weeklyBetAmount = _this$entryModel$attr2.weeklyBetAmount,
        startTime = _this$entryModel$attr2.startTime,
        stopTime = _this$entryModel$attr2.stopTime,
        amount = _this$entryModel$attr2.amount,
        payTime = _this$entryModel$attr2.payTime;
      const _this$entryModel$attr3 = this.entryModel.attributes,
        isEntry = _this$entryModel$attr3.isEntry,
        paymentTypeText = _this$entryModel$attr3.paymentTypeText;
      weeklyBetAmount = svs.utils.format.Currency(weeklyBetAmount);
      amount = svs.utils.format.Currency(amount);
      startTime = svs.utils.date.FormatTime('d/M', startTime);
      stopTime = svs.utils.date.FormatTime('d/M', stopTime);
      payTime = svs.utils.date.FormatTime('d/M', payTime);
      const message = ["Prenumerationen kostar ".concat(weeklyBetAmount, " kr / vecka och betalas m\xE5nadsvis i f\xF6rskott.")];
      if (isEntry) {
        message[0] += " N\xE4r du klickar ".concat(action, " debiteras du ").concat(amount, " kr f\xF6r perioden ").concat(startTime, " - ").concat(stopTime, ". D\xE4refter debiteras du m\xE5nadsvis den 28:e varje m\xE5nad.");
      } else {
        message[0] += " N\xE4sta betalning p\xE5 ".concat(amount, " kr dras fr\xE5n ditt ").concat(paymentTypeText, " den ").concat(payTime, ".");
      }
      message.push('Du kan ändra din prenumeration fram till den 23:e varje månad.');
      if (isEntry) {
        message.push("<strong>Viktig information!</strong><br/>\n          Din prenumeration f\xF6r perioden ".concat(startTime, " - ").concat(stopTime, " g\xE5r inte att annullera n\xE4r du startat prenumerationen."));
      }
      message.push("<a target='_blank' href='".concat(svs.core.urlMapping.get('termsIntegrityHome'), "'>Villkor f\xF6r prenumeration</a>"));
      return {
        title: "".concat(action, " din prenumeration"),
        message: message.map(text => ({
          type: svs.ui.dialog.message.TEXT,
          text,
          align: svs.ui.dialog.message.align.CENTER
        }))
      };
    }
  });
})(Backbone, _, svs);

 })(window);